import VBToggle from './toggle';
import { installFactory } from '../../utils/plugins';
var directives = {
  VBToggle: VBToggle
};
export { VBToggle };
export default {
  install: installFactory({
    directives: directives
  })
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/bootstrap-vue/es/directives/toggle/index.js
// module id = null
// module chunks = 